<template>
    <div class="row">
        <div class="col-sm-12">

            <h2 style="margin-bottom:10px">High-Water Mark</h2>

            <div class="table-responsive" v-loading="loading">
                <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Month</th>
                        <th>High-Water Mark</th>
                        <th>Billable</th>
                        <th>Net Invoice</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="l in periods">
                          <td>{{ l.month }}</td>
                          <td>{{ money(l.high_water_mark) }}</td>
                          <td>{{ money(l.billable) }}</td>
                          <td>{{ money(l.net_billable) }}</td>
                      </tr>
                    </tbody>
                </table>
            </div>

            <h2 style="margin-bottom:10px">Upsells</h2>

            <div>
                <form class="filter-group list-filter" style="display: flex; flex-wrap: wrap;">
                    <div style="margin: 10px 10px 0 0">Show upsell commissions eligible in:</div>
                    <div class="form-group">
                        <el-select v-model="filter.date" @change="refresh">
                            <el-option :label="o.name" :key="o.date" :value="o.date" v-for="o in months"></el-option>
                        </el-select>
                    </div>
                    <div class="form-group">
                        <btn cssClass="btn btn-secondary" icon="fas fa-redo-alt" :click="refresh">Filter</btn>
                    </div>
                    <div class="form-group" style="margin-left: auto; width: auto;">
                        <btn cssClass="btn btn-danger is-aligned-right" icon="fas fa-plus" :click="createUpsell">Add Upsell</btn>
                    </div>
                </form>
            </div>


            <div class="table-responsive" v-loading="loading">
                <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Upsell Name</th>
                        <th>High-Water Mark Basis</th>
                        <th>Account Manager</th>
                        <th>Upsell</th>
                        <th>Month Net Invoice</th>
                        <th>Eligible Commission</th>
                        <th>Months Remaining</th>
                        <th>Upsell Commission</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="l in upsells">
                          <td>{{ l.name }}</td>
                          <td>{{ money(l.high_water_mark_basis) }}</td>
                          <td>{{ l.account_manager }}</td>
                          <td>{{ money(l.upsell) }}</td>
                          <td>{{ money(l.net_invoice) }}</td>
                          <td>{{ money(l.eligible_commission) }}</td>
                          <td>{{ l.months_remaining }}</td>
                          <td>{{ money(l.upsell_commission) }}</td>
                          <td><a href="#" @click.prevent="editUpsell(l.id)">Update</a></td>
                      </tr>
                    </tbody>
                </table>
            </div>

            <upsell-update
                :show="show_dialogs.update"
                :data_id="show_dialogs.upsell_id"
                :employer_id="employer_id"
                @close="show_dialogs.update = false; refresh()"
                ></upsell-update>
            <employer-notes-wrapper :employer-id="employer_id" />
        </div>
    </div>
</template>

<script>
import UpsellUpdate from "./upsell-update";

export default {
    components: {UpsellUpdate},
    props: [
        'employer_id',
        'months',
    ],
    data() {
        return {
            filter: {
                date: _.last(this.months).date
            },
            show_dialogs: {
                'update': false,
                'upsell_id': null
            },
            periods: [],
            upsells: [],
            loading: true
        };
    },
    methods: {
        createUpsell() {
            this.show_dialogs.upsell_id = null;
            this.show_dialogs.update = true;
        },
        editUpsell(id) {
            this.show_dialogs.upsell_id = id;
            this.show_dialogs.update = true;
        },
        refresh() {
            this.loading = true;
            return axios.post(url(`admin/employer/${this.employer_id}/upsell/list/data`), { date: this.filter.date })
                .then((response) => {
                    this.periods = response.data.periods;
                    this.upsells = response.data.upsells;
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.refresh();
    }
}
</script>
